snt-footer {
  display: flex;
  width: 100%;
  flex-flow: column wrap;
  background: #ffffff;

  .footer {
    max-width: 1440px;
    width: 100%;
    margin: auto;
    background-color: $color-white;
    border-top: 1px solid $color-primary-grey;

    .spacings {
      @include layout();
    }
  }

  .col {
    box-sizing: border-box;

    &:first-child,
    &:nth-child(3) {
      padding: 0 !important;
    }
  }

  .h5 {
    margin-bottom: 0.938em;
    font-size: 1em;
    line-height: 1;
    display: inline-block;
    width: 100%;
  }

  @media (max-width: map-get($grid-breakpoints, md)) {
    .col {
      margin-top: 40px;
      padding: 0;
    }

    .col:nth-child(3),
    .col:nth-child(4) {
      margin-top: 30px;
    }
  }

  .footer-actions {
    snt-nav-item:last-child {
      display: inline-block;
      padding-bottom: 40px;
    }
  }

  @include viewport($viewport-md) {
    .h5 {
      margin-bottom: 1.25em;
    }
  }

  @include viewport($viewport-lg) {
    .h5 {
      margin-bottom: 1.563em;
    }
    .footer-actions {
      snt-nav-item:last-child {
        padding-bottom: 60px;
      }
    }
  }

  @include viewport($viewport-xl) {
    .h5 {
      margin-bottom: 1.875em;
    }

    .footer-actions {
      snt-nav-item:last-child {
        padding-bottom: 60px;
      }
    }
  }
}

snt-footer snt-link,
snt-footer snt-link a {
  line-height: 1.2;
}

snt-footer snt-nav-item {
  padding-bottom: 0.625em;
  width: 100%;
  text-align: left;

  snt-link a {
    font-size: 0.875em;
    color: $color-black;
    padding: 0;
    text-decoration: none;
    .icon-new-window:before {
      color: $color-black;
    }

    background-image: linear-gradient(transparent, transparent),
      linear-gradient($color-primary-accent, $color-primary-accent);
    background-size: 100% 1px, 0 1px;
    background-position: 100% 100%, 1px 100%;
    background-repeat: no-repeat;
  }

  snt-link a:focus,
  snt-link a:focus-within,
  snt-link a:hover {
    color: $color-primary-accent;
    background-image: linear-gradient(transparent, transparent),
      linear-gradient($color-primary-accent, $color-primary-accent);

    .icon-new-window:before {
      color: $color-primary-accent;
    }
  }

  snt-link a:focus {
    outline: 1px solid $color-primary-accent;
  }
}

snt-footer .nav-link {
  padding: 0;
  position: relative;

  span.icon-font {
    position: relative;
    right: 0;
  }
}

.footer-row {
  border-top: 1px solid #6f6f6f;
  border-bottom: 1px solid #6f6f6f;
  margin-bottom: 1.875em;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  padding-left: 0 !important;

  .col-md-12 {
    padding-left: 0;
  }

  snt-nav {
    flex-direction: row;
  }

  snt-nav-item {
    display: inline;
    line-height: 1;
    padding-right: 30px;

    a {
      font-size: 0.75em;
    }
  }
}

.footer-legal {
  padding: 0 !important;
  margin: 0;

  p2,
  p {
    font-size: 12px;
    line-height: 1.5;
    display: table;
    margin-bottom: 0.475em;
  }

  a {
    font-size: 12px;
    word-break: break-word;
  }
}

@media (max-width: map-get($grid-breakpoints, md)) {
  snt-footer a {
    margin-bottom: 9px;
  }
}

@media (max-width: map-get($grid-breakpoints, sm)) {
  .footer-row snt-nav {
    flex-direction: column;
    align-items: baseline;
  }
}

.legal_copy {
  display: none;
}
